import { useState } from "react";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { queryClient } from "@/shared/lib/react-query";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { useBuildSignLine } from "../mutate-hooks/use-build-sign-line";

export const useSetupSigningString = (
  mainJournalData: any,
  search?: string,
) => {
  const [signingString, setSigningString] = useState("");
  const [signingItemId, setSigningItemId] = useState<string | null>(null);
  const { mutateAsync: getSigningXml } = useBuildSignLine();

  const setupSigningString = async (
    params: {
      sectionThreeListId: string;
      itemNoVersionId: string;
      signerEmployeeId: string;
    },
    onOpen: () => void,
  ) => {
    setSigningItemId(params.itemNoVersionId);
    try {
      const res = await getSigningXml(params);
      setSigningString(res);
      onOpen();
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSection3({
          sectionThreeListId:
            mainJournalData?.mainJournal?.section3?.sectionId || "",
          search,
        }).queryKey,
      });
    } catch (err: any) {
      notification.error({
        message: NOTIFICATION_MESSAGES.XML_SIGN_GENERATION_ERROR, // "Ошибка при генерации XML подписи"
        description: err?.message || "Неизвестная ошибка",
        placement: "topRight",
      });
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSection3({
          sectionThreeListId:
            mainJournalData?.mainJournal?.section3?.sectionListId || "",
          search,
        }).queryKey,
      });
    } finally {
      setSigningItemId(null);
    }
  };

  return {
    signingString,
    setupSigningString,
    signingItemId,
  };
};
